<form class="container" [formGroup]="androidBuildForm" (ngSubmit)="generateAAB()">

  <!-- Release Configuration Section -->
  <div class="section" *ngIf="(!buildStart || value == 100 || error) && !checkingStatus">
    <div class="title">{{ 'Release Configuration' | translate }}</div>
    <div class="releaseKeys">
      <div class="releaseInfo">
        <div class="releaseTitle">{{ 'Release Keys' | translate }}</div>
        <div class="releaseDesc">
          {{ 'Secure your app by generating or uploading encryption keys. These are required for Play Store distribution.' | translate }}
        </div>
      </div>
      <div class="releaseActions">
        <!-- Hidden file input for encryption -->
        <input
          type="file"
          #encryptionFileInput
          style="display: none"
          formControlName="encryption_filepath"
          id="encryption_filepath"
          (change)="processFileUpload($event, 'application/x-x509-ca-cert', 'encryption_filepath')"
          accept="application/x-x509-ca-cert"
        />

        <div class="uploadedFileInfo" *ngIf="uploadedFileName">
          <span>{{ uploadedFileName }}</span>
          <button type="button" class="removeFileBtn" (click)="clearEncryptionData()">✕</button>
        </div>

        <button type="button" class="uploadBtn" (click)="encryptionFileInput.click()">
          <img src="assets/icons/cloud.svg" alt="upload" />
          <span>{{ 'Upload Encryption File' | translate }}</span>
        </button>

        <button type="button" class="generateKeysBtn" (click)="generateReleaseKeys()">
          <img src="assets/icons/key.svg" alt="key" />
          <span>{{ 'Generate Release Keys' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- App Versioning Section -->
  <div class="section" *ngIf="(!buildStart || value == 100 || error) && !checkingStatus">
    <div class="title">{{ 'App Versioning' | translate }}</div>
    <div class="contentContainer">

      <!-- Android Version -->
      <div class="version">
        <div class="labelRow">
          <label for="androidVersion">{{ 'Android Version' | translate }}</label>
          <span class="latestVersion">{{ 'Latest Android Version' | translate }}: {{ latestVersionName || '-' }}</span>
        </div>
        <input
          type="number"
          id="androidVersion"
          formControlName="androidVersion"
          placeholder="0"
          min="0.1"
          step="0.1"
          max="9999"
        />
        <div class="hint">{{ 'Format example: 1.0 or 1.1' | translate }}</div>
      </div>

      <!-- Android Version Code -->
      <div class="version">
        <div class="labelRow">
          <label for="androidVersionCode">{{ 'Android Version Code' | translate }}</label>
          <span class="latestVersion">{{ 'Latest Android Version' | translate }}: {{ latestVersionCode || '-' }}</span>
        </div>
        <input
          type="number"
          id="androidVersionCode"
          formControlName="androidVersionCode"
          placeholder="0"
          min="1"
          step="1"
          max="9999"
          (input)="onInput($event)"
        />
        <div class="hint">{{ 'Integer value (e.g. 1, 2, 3)' | translate }}</div>
      </div>

    </div>

    <!-- Auth0 Note -->
    <div *ngIf="noteMessage" class="noteContainer">
      <span class="material-icons-outlined note-icon">info</span>
      <p class="note">{{ noteMessage | translate }}</p>
    </div>
  </div>

  <!-- Build In Progress -->
  <div class="section buildStatusSection" *ngIf="buildStart && !checkingStatus && !error">
    <div class="title">
      <span *ngIf="value < 100">{{ 'Generating Android App...' | translate }}</span>
      <span *ngIf="value == 100">{{ 'Android Application Generated ✓' | translate }}</span>
    </div>
    <div class="buildProgress">
      <div class="progressBar">
        <div class="progressFill" [style.width.%]="value"></div>
      </div>
      <span class="progressValue">{{ value }}%</span>
    </div>
    <div
      *ngIf="value == 100 && ((!builderService.standalone && builderService.selectedProjectDomain) || builderService.standalone)"
      class="downloadSection"
    >
      <a
        href="{{ downloadAABBtn }}"
        *ngIf="builderService.selectedProjectDomain !== 'https://demo.stacksclients.com' || webviewApp"
        class="downloadBtn"
      >
        {{ 'Download .aab File' | translate }}
      </a>
    </div>
  </div>

  <!-- Checking Status -->
  <div class="section buildStatusSection" *ngIf="checkingStatus && !error">
    <div class="title">{{ 'Checking Build Status' | translate }}</div>
    <div class="buildProgress">
      <div class="progressBar indeterminate"></div>
    </div>
  </div>

  <!-- Error State -->
  <div class="section buildStatusSection errorSection" *ngIf="error">
    <div class="title">{{ 'Build Failed' | translate }}</div>
    <div class="errorBody">
      <p *ngIf="buildErrorMsg && buildErrorMsg !== ''">{{ buildErrorMsg }}</p>
      <p *ngIf="!buildErrorMsg || buildErrorMsg === ''">
        {{ 'An error occurred while building.' | translate }}<br />
        {{ 'Please try again. If the error persists, contact support.' | translate }}
      </p>
      <button type="button" class="generateKeysBtn" (click)="rebuildApp()">{{ 'Rebuild App' | translate }}</button>
    </div>
  </div>

</form>

<!-- Submit Button — outside form to match original layout -->
<button
  type="submit"
  (click)="generateAAB()"
  [disabled]="androidBuildForm.invalid"
  *ngIf="(!buildStart || value == 100 || error) && !checkingStatus"
>
  <img src="assets/icons/wizard.svg" alt="wizard" />
  <div>{{ 'Generate Android App' | translate }}</div>
</button>
